export default [
  {
    name: 'claudia',
    age: 57,
    stories: [
      3,
      4,
      5
    ]
  },
  {
    name: 'hubert',
    age: 67,
    stories: [
      6,
      7,
      8
    ]
  },
  {
    name: 'jordy',
    age: 32,
    stories: [
      9,
      10,
      11
    ]
  },
  {
    name: 'wim',
    age: 71,
    stories: [
      12,
      13,
      14
    ]
  },
  {
    name: 'yalda',
    age: 48,
    stories: [
      15,
      16,
      17
    ]
  },
  {
    name: 'wouter',
    age: 'Coach',
    stories: [
      1,
      2
    ]
  }
]
